import React, { Fragment, useState, useEffect } from "react";

import "../../../assets/styles/customer/account/wallet.scss";
import "../../../assets/styles/general.scss";
import "../../../assets/styles/utils.scss";
import { Table } from "react-bootstrap";

import { useTranslation } from "react-i18next";
import moment from "moment";
import { ClipLoader } from "react-spinners";
import { apiJson } from "../../../Api";

const Rewards = () => {
  const [loading, setLoading] = useState(false);
  const [rewards, setRewards] = useState([]);
  const [rewardPoints, setRewardPoints] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    apiJson.rewards.getRewardPoints().then((response) => {
      if (response.success) {
        setRewardPoints(response.data);
      }
    });

    apiJson.rewards.getRewards().then((response) => {
      if (response.success) {
        setRewards(response.data);
      }

      setLoading(false);
    });
  }, []);

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const renderTable = () => {
    return (
      <>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <ClipLoader color="#000" loading size={20} />
          </div>
        ) : (
          <>
            <div className="title">{t("rewards.rewards_history")}</div>
            <div className="credits-table wallet-table">
              <div className="table-responsive">
                <Table hover className="overflow-auto">
                  <thead>
                    <tr className="table-head">
                      <td className="pl-4 w-10 fw-500">{t("rewards.date")}</td>
                      <td className="w-10 fw-500">
                        {t("rewards.transaction_type")}
                      </td>
                      <td className="w-10 fw-500">{t("rewards.status")}</td>
                      <td className="w-10 fw-500">{t("wallet.details")}</td>
                      <td className="w-10 fw-500">
                        {t("rewards.reward_points")}
                      </td>
                      <td className="pl-4 w-10 fw-500">
                        {t("rewards.expiry_date")}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {rewards.map((reward) => {
                      return (
                        <tr key={reward.id}>
                          <td className="date gray word-break-none pl-4">
                            {moment(reward.created_at).format("ll")}
                          </td>
                          <td>{capitalize(reward.transaction_type)}</td>
                          <td>{capitalize(reward.status)}</td>
                          <td>
                            {reward.reward_credited ||
                              reward.reward_used ||
                              reward.reward_expired}
                          </td>
                          <td
                            className="amount  word-break-none"
                            style={{
                              color:
                                reward.status === "expired" ||
                                reward.status === "used"
                                  ? "#e00"
                                  : "green",
                            }}
                          >
                            {reward.status === "expired" ||
                            reward.status === "used"
                              ? "-"
                              : "+"}{" "}
                            {reward.points}
                          </td>
                          <td
                            className="amount word-break-none"
                            style={{ color: "#e00" }}
                          >
                            {moment(reward.expires_at).format("ll")}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
        )}
        {!rewards?.length && !loading && (
          <div style={{ margin: "40px", textAlign: "center" }}>
            {t("rewards.no-credit")}
          </div>
        )}
      </>
    );
  };

  return (
    <Fragment>
      <div className="customer-wallet w-100 py-3">
        <div className="d-flex justify-content-between">
          <div>
            <div className="title">{t("rewards.title")}</div>
            <p className="gray below-title">{t("rewards.keep-track-label")}</p>
          </div>
          <div>
            <div className="right green">{t("rewards.available-points")}</div>
            <div className="right start">{rewardPoints.total_points}</div>
          </div>
        </div>

        {renderTable()}
      </div>
    </Fragment>
  );
};

export default Rewards;
